import { AttendanceMain } from '../../models/attendanceModel'
import { AttendanceActionTypes } from '../actions/attendanceAction'
import InitialState from './initialState'
const initialState: AttendanceMain = InitialState.attendance
export default function Attendancereducer(
  state: AttendanceMain = initialState,
  action: any
) {
  switch (action.type) {
    case AttendanceActionTypes.Attendance_Dashboard_Success_Action:
      return {
        ...state,
        attendance_dashboard: action.payload,
        attendance_payload: undefined,
      }
    case AttendanceActionTypes.Pending_Approval_Success_Action:
      return { ...state, pending_approval: action.payload }
    // case AttendanceActionTypes.Uploaded_Attendance__View_Success_Action:
    //   return { ...state, upload_attendance_view: action.payload };
    case AttendanceActionTypes.Uploaded_Attendance__View_Success_Action:
      return {
        ...state,
        employee_list: action.payload.list,
        total_count: action.payload.count,
        attendence_fields: action.payload.attendence_fields,
      }
    case AttendanceActionTypes.Attendance_Detail_Payload_Success_Action:
      return { ...state, attendance_payload: action.payload }
    case AttendanceActionTypes.Approve_Attendance_List_Success_Action:
      return { ...state, attendance_approve_list: action.payload }
    case AttendanceActionTypes.Attendance_Time_Sheet_Success_Action:
      return { ...state, attendance_timesheet_list: action.payload }

    // Attendence New
    case AttendanceActionTypes.Get_All_Emp_Monthly_Attendence_Success_Action: {
      const payload = action.payload
      const data =
        payload?.data ??
        payload?.rows ??
        payload?.list ??
        payload?.get_all_emp_monthly_attendece ??
        payload?.monthly_attendance ??
        payload?.attendance_list ??
        (Array.isArray(payload) ? payload : [])
      const count =
        payload?.count ??
        payload?.pagination?.total ??
        payload?.pagination?.totalCount ??
        payload?.total ??
        payload?.total_count ??
        payload?.totalCount ??
        (Array.isArray(data) ? data.length : 0)
      return {
        ...state,
        get_all_emp_monthly_attendece: Array.isArray(data) ? data : [],
        monthly_attendance_count: count,
      }
    }

      //day wise
    case AttendanceActionTypes.Get_DAY_WISE_Attendence_Success_Action:
      return { ...state, daywiseAttendance: action.payload }

    case AttendanceActionTypes.Emp_Monthly_Attendence_Details_Success_Action:
      return { ...state, emp_monthwise_attendence_deatails: action.payload }
    case AttendanceActionTypes.Send_For_Approval_Details_Success_Action:
      return { ...state, send_for_approval: action.payload }
    case AttendanceActionTypes.View_Team_Attendance_Details_Success_Action: {
      const payload = action.payload;
      const data = payload?.data ?? payload;
      const count =
        payload?.pagination?.total ??
        payload?.pagination?.totalCount ??
        (Array.isArray(data) ? data.length : 0);
      return {
        ...state,
        view_team_attendance: Array.isArray(data) ? data : [],
        view_team_attendance_count: count,
      }
    }
    case AttendanceActionTypes.Pending_Attendance_List_Success_Action:
      return { ...state, pending_attendance_list: action.payload }
    case AttendanceActionTypes.Edit_Attendance_Success_Action:
      return { ...state, edit_attendance: action.payload }
    case AttendanceActionTypes.My_Attendance_Success_Action:
      return { ...state, my_attendance_details: action.payload }
    case AttendanceActionTypes.Get_Emp_Wise_Yearly_Attendance_Success_Action:
      return { ...state, emp_yearly_attendance_summary: action.payload }
    case AttendanceActionTypes.Get_Attendance_Dashboard_Master_Success_Action:
      return { ...state, attendance_dashboard_master: action.payload }
    case AttendanceActionTypes.Dashboard_Details_Success_Action:
      return { ...state, dashboard_details: action.payload }
    case AttendanceActionTypes.Get_Todays_Timesheet_Success_Action:
      return { ...state, get_all_timesheet_details_today: action.payload }
    case  AttendanceActionTypes.Attendance_temporal_Set_Action:
        return {...state, approval_temp: action.payload}
    case AttendanceActionTypes.Get_Attendance_Failure_Logs_Success_Action: {
      const payload = action.payload
      const data = payload?.data ?? (Array.isArray(payload) ? payload : [])
      const pagination = payload?.pagination
      const count =
        pagination?.total ??
        payload?.total ??
        (Array.isArray(data) ? data.length : 0)
      return {
        ...state,
        attendance_failure_logs: Array.isArray(data) ? data : [],
        attendance_failure_logs_count: count,
      }
    }
    case AttendanceActionTypes.Get_Attendance_Failure_Log_Detail_Success_Action:
      return { ...state, attendance_failure_log_detail: action.payload?.data ?? action.payload }
    case AttendanceActionTypes.Update_Attendance_Failure_Log_Status_Success_Action:
      return { ...state }
    
    default:
      return state
  }
}
